import { postEventImages2026 } from 'constants/images'
import { ChevronDown } from 'lucide-react'
import React from 'react'

const Run2026: React.FC = () => {
    interface EventImageProps {
        src: string
        imageText?: string
    }

    const EventImage: React.FC<EventImageProps> = ({ src, imageText }) => {
        return (
            <img
                src={src}
                loading="lazy"
                alt={`Running event ${imageText}`}
                className="w-full rounded-2xl shadow-md hover:opacity-90 transition"
            />
        )
    }

    return (
        <div>
            <section
                className="relative bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(assets/Kilverts-Field.jpg)` }}>
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-white/25 to-white/25 bg-white/25"></div>

                {/* Top Wave Background - Mobile */}
                <div className="block lg:hidden">
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 350" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#6aa4eb"
                            />
                        </svg>
                    </div>
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 400" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#0071c0"
                            />
                        </svg>
                    </div>
                </div>

                {/* Top Wave Background - Desktop */}
                <div className="hidden lg:block">
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 200" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#69b4eb"
                            />
                        </svg>
                    </div>
                    <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
                        <svg
                            className="block w-full h-[400px]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="600 0 500 250" /* min-x min-y width height */
                            preserveAspectRatio="none">
                            <path
                                d="M0,0V80c70,30,150,50,230,30s150-90,230-90,160,60,240,80,160-20,240-30,160,40,240,30V0Z"
                                fill="#0071c0"
                            />
                        </svg>
                    </div>
                </div>

                {/* Header - Text */}
                <div className="absolute ml-4 mt-2 z-10">
                    <h1 className="text-3xl text-white font-extrabold sm:text-5xl">Grays Run</h1>
                    <h2 className="text-1xl text-yellow-400 font-extrabold sm:text-3xl">
                        Walk, Jog or Run
                    </h2>
                </div>

                {/* Content */}
                <div className="relative flex flex-col justify-end items-center lg:justify-center lg:items-center text-center mx-auto max-w-screen-xl px-4 pt-32 pb-16 sm:px-6 lg:h-screen min-h-[500px] z-10">
                    <div className="max-w-xl lg:max-w-5xl">
                        <h1 className="text-3xl font-extrabold sm:text-5xl">
                            Grays Run 6th September 2026
                        </h1>
                    </div>
                    <div className="max-w-xl lg:max-w-3xl">
                        <p className="mt-4 sm:text-xl/relaxed font-bold">
                            <a
                                href="https://www.racetimeresult.co.uk/results/grays-river-10k"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white grays-run-bg-blue hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">
                                Race results
                            </a>
                        </p>
                    </div>
                    <a
                        href="#post-event-images"
                        aria-label="Scroll down to view event photos"
                        className="mt-8 inline-flex flex-col items-center gap-1 rounded-lg text-black-400 animate-bounce [animation-duration:2s] hover:text-white focus:outline-none">
                        <span className="text-sm font-semibold">View event photos</span>
                        <ChevronDown size={32} aria-hidden="true" />
                    </a>
                </div>
            </section>

            {/* Masonry-style grid */}
            <div id="post-event-images" className="m-8 scroll-mt-4">
                {/* <div className="columns-1 sm:columns-2 md:columns-3 gap-4 space-y-4"> */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {Object.values(postEventImages2026).map((image, index) => (
                        <EventImage
                            key={image}
                            src={image}
                            imageText={`2026 event image ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Run2026
